import CorpBrands from "components/Homepage/Brands"
import colors from "theme/colors"
import { extractProperty } from "utils"

type Props = {
  data: any
  keyForComponent: any
}

function BrandsValueWrapper({ data, keyForComponent }: Props) {
  const title = extractProperty(data, "mainTitle")
  const blocks = extractProperty(data, "carrouselInner")
  const dat = {
    __typename: "BasicBlockListItem",
    blockType: "linksLists",
    properties: [
      {
        __typename: "BasicProperty",
        propertyName: "linkToAll",
        propertyValue: {
          __typename: "BasicMultiUrlPicker",
          valueType: "BasicMultiUrlPicker",
          links: [],
        },
      },
      {
        __typename: "BasicProperty",
        propertyName: "listsTitle",
        propertyValue: {
          __typename: "BasicPropertyValue",
          valueType: "BasicPropertyValue",
          value: "מותגי הקבוצה",
        },
      },
      {
        __typename: "BasicProperty",
        propertyName: "lists",
        propertyValue: {
          __typename: "BasicBlockListModel",
          valueType: "BasicBlockListModel",
          blocks: [
            {
              __typename: "BasicBlockListItem",
              blockType: "linksList",
              properties: [
                {
                  __typename: "BasicProperty",
                  propertyName: "title",
                  propertyValue: {
                    __typename: "BasicPropertyValue",
                    valueType: "BasicPropertyValue",
                    value: title,
                  },
                },
                {
                  __typename: "BasicProperty",
                  propertyName: "urls",
                  propertyValue: {
                    __typename: "BasicBlockListModel",
                    valueType: "BasicBlockListModel",
                    blocks: blocks.map((item: any) => {
                      const logo = extractProperty(item, "logo")
                      const links = extractProperty(item, "link")
                      const description = extractProperty(item, "text")
                      return {
                        __typename: "BasicBlockListItem",
                        blockType: "linkBlock",
                        properties: [
                          {
                            __typename: "BasicProperty",
                            propertyName: "link",
                            propertyValue: {
                              __typename: "BasicMultiUrlPicker",
                              valueType: "BasicMultiUrlPicker",
                              links,
                            },
                          },
                          {
                            __typename: "BasicProperty",
                            propertyName: "linkTitle",
                            propertyValue: {
                              __typename: "BasicPropertyValue",
                              valueType: "BasicPropertyValue",
                              value: links?.[0]?.name,
                            },
                          },
                          {
                            __typename: "BasicProperty",
                            propertyName: "description",
                            propertyValue: {
                              __typename: "BasicPropertyValue",
                              valueType: "BasicPropertyValue",
                              value: description,
                            },
                          },
                          {
                            __typename: "BasicProperty",
                            propertyName: "linkImage",
                            propertyValue: {
                              __typename: "BasicMediaPicker",
                              valueType: "BasicMediaPicker",
                              mediaItems: [
                                {
                                  __typename: "BasicMediaPickerItem",
                                  id: 1121,
                                  url: logo,
                                },
                              ],
                            },
                          },
                        ],
                      }
                    }),
                  },
                },
              ],
            },
          ],
        },
      },
    ],
  }
  return (
    <CorpBrands
      data={dat}
      mainTitleColor="black"
      mainTitle={title}
      background={`${colors.bluishGray}4D`}
      keyForComponent={keyForComponent}
    />
  )
}

export default BrandsValueWrapper
